<template>
  <div class="digital-library">
    <Header
      :pageTitle = "navigation.verlag.headerTitle[lang]"
      schema="default"
    />
    <b-container class="pb-1"
      v-if="pageData"
    >
    <Breadcrumb
      :pathToPage="pathToThisPage"
    />
    <b-row no-gutters>
      <b-col
        md="12"
      >
      <!-- <h1>{{ pageData.titel }}</h1> -->
        <div
          v-if="pageData.einleitung"
          v-html="normalize(pageData.einleitung)"
          class="lead lead-box mb-0"
        />
      </b-col>
      </b-row>
    </b-container>
    <SektionDBRubriken/>
  </div><!-- .homepage -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SektionDBRubriken from '@/components/SektionDBRubriken.vue'
import Header from '@/components/Header.vue'
import Breadcrumb from '@/components/subparts/Breadcrumb-subpart.vue'
import initView from '../mixins/initView'

export default {
  name: 'verlag',
  data () {
    return {
      hbg: ''
    }
  },
  components: {
    SektionDBRubriken,
    Header,
    Breadcrumb
  },
  mixins: [
    initView
  ],
  methods: {
    ...mapActions({

    }),
    fetchData () {

    }
  },
  computed: {
    ...mapGetters({
      pageData: 'getDLPageData',
      navigation: 'getNavigation',
      lang: 'getLanguage',
      sectionsData: 'getDLSectionsData',
      newRoute: 'getNewRoute'
    }),
    pathToThisPage () {
      let path = []
      let nav = this.$store.state.navigation
      let lang = this.$store.state.lang

      path[0] = {
        name: nav.home.navTitle[lang],
        slug: '/',
        disabled: false
      }
      path[1] = {
        name: nav.verlag.navTitle[lang],
        slug: '/verlag',
        disabled: true
      }
      return path
    }
  },
  created () {
    if (this.$store.state.dlPageData.de === undefined) {
      this.$store.dispatch('fetchApiDLPageData')
    } else {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
